export const RESOURCES_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/resources", name: "Resources" },
];

export const TEAM_MEMBERS_TABLE_HEADERS = ["Name", "Employee ID", "Role", "Client", "Status"];
export const VENDORS_TABLE_HEADERS = ["Name", "Address"];

export type ResourceTab = "all" | "supervisors" | "technicians" | "cleaners" | "vendors";

export const RESOURCE_TABS: { key: ResourceTab; label: string }[] = [
  { key: "all", label: "All" },
  { key: "supervisors", label: "Supervisors" },
  { key: "technicians", label: "Technicians" },
  { key: "cleaners", label: "Custodians" },
  { key: "vendors", label: "Vendors" },
];
